import styled from '@emotion/styled';
import { IInternalLinkItem } from '../../../../ui';
import React from 'react';

import { PassengersPageId } from '../../../app/pages/domain/constants/PageId';
import { useUrlForPageId } from '../../../app/pages/ui/utils/useUrlForPageId';

import { CallToAction, ICallToActionTheme } from '../../../shared/components';
import { useTranslation } from '../../../shared/i18n/translate/useTranslation';

import { isDeparture } from './helpers/isDeparture';
import ContentWrap from '../../../../ui/components/Layout/ContentWrap';

export const FlightDetailPageDepartureCTA = () => {
	const { t } = useTranslation();
	const departure = isDeparture();
	const parkingUrl = useUrlForPageId(PassengersPageId.Parking);

	if (!departure) return null;

	const details = {
		callToActionTheme: 'grey' as ICallToActionTheme,
		title: t('web_flight_detail_departure_cta_title'),
		links: [
			{
				key: 'parkingUrl',
				type: 'internal-link',
				url: parkingUrl,
				title: t('web_flight_detail_departure_cta_button_label'),
			} as IInternalLinkItem,
		],
		description: t('web_flight_detail_departure_cta_description'),
	};

	return (
		<ContentWrap>
			<StyledCallToAction {...details} />
		</ContentWrap>
	);
};

const StyledCallToAction = styled(CallToAction)`
	margin-top: 42px;
`;
